import * as e from "react";
const h = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M19.4 7.5h3.1V6h-3.1A2.3 2.3 0 0015 6H9.8V3.7h-6V6H1.5v1.5h2.3v2.3h6V7.5H15a2.3 2.3 0 001.4 1.4v5.5a3 3 0 00-2.1 2.1H1.5V18h12.9a3 3 0 005.7 0h2.4v-1.5h-2.4a3 3 0 00-2.1-2.1V8.9a2.3 2.3 0 001.4-1.4zm-11.1.8h-3v-3h3v3zm10.4 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }));
export {
  h as ReactComponent
};
